import React from 'react'
import cx from "classnames";

function SwitchVehiculo({ rounded = false, isToggled, onToggle }){
  const sliderCX = cx('slider', {
    rounded: rounded
  });

if (isToggled){
  //console.log("feswitchprendidotg");
}else{
  //console.log("feswitchapagadotg");

}
  
return (
    <label className='switch'>
      <input type='checkbox' checked={isToggled} onChange={onToggle} />
      <span className={sliderCX} />
    </label>
  );
};

export default SwitchVehiculo;